import { render, staticRenderFns } from "./StatusLeyend.vue?vue&type=template&id=5f706ee1&scoped=true&"
import script from "./StatusLeyend.vue?vue&type=script&lang=js&"
export * from "./StatusLeyend.vue?vue&type=script&lang=js&"
import style0 from "./StatusLeyend.vue?vue&type=style&index=0&id=5f706ee1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f706ee1",
  null
  
)

export default component.exports